import { abbreviatedNumber } from 'src/pages/Yearbooks/presentation/components/Charts/utils';

import { YearbookChart } from '../styles';

interface LineChartProps {
  data: {
    name: string;
    type: 'column' | 'line';
    data: number[];
  }[];
  animationEnabled?: boolean;
  categories: string[];
}

export default function LineColumnChart(props: LineChartProps) {
  return (
    <YearbookChart
      series={props.data}
      type="line"
      options={{
        chart: {
          type: 'line',
          stacked: false,
          toolbar: {
            show: false,
          },
          animations: {
            enabled: props.animationEnabled ?? true,
          },
        },

        dataLabels: {
          formatter: (val: any) => {
            if (isNaN(Number(val))) {
              return val;
            }

            return Number(val).toFixed(2);
          },
        },
        stroke: {
          width: [0, 2, 5],
          curve: 'smooth',
        },
        plotOptions: {
          bar: {},
        },
        tooltip: {
          y: {
            formatter: function (value: any, opts: any) {
              if (isNaN(Number(value))) {
                return value;
              }

              if (opts.seriesIndex === 1) {
                return value.toLocaleString('pt-BR', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                });
              }

              const formatedValue = abbreviatedNumber(value);

              return `R$ ${formatedValue}`;
            },
          },
        },
        fill: {
          opacity: [0.85, 0.25, 1],
          gradient: {
            inverseColors: false,
            shade: 'light',
            type: 'vertical',
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [0, 100, 100, 100],
          },
        },
        labels: props.categories,
        markers: {
          size: 0,
        },
        grid: {
          show: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          type: 'date',
          labels: {
            show: props.categories.length <= 6 ? true : false,
          },
        },
        yaxis: [
          {
            labels: {
              show: false,
            },
            min: 0,
          },
          {
            opposite: true,
            labels: {
              show: false,
            },
          },
        ],
        responsive: [
          {
            breakpoint: 1000,
            options: {
              chart: {
                animations: {
                  enabled: false,
                },
              },
            },
          },
        ],
        colors: [
          '#A61F69',
          '#FD841F',
          '#600446',
          '#F2CD5C',
          '#35D0BA',
          '#CD104D',
        ],
      }}
    />
  );
}
